/**
 * Safely extract the Models array from a paged adapter response.
 * The adapter may return { data: { Models: [...] } } or { Models: [...] }.
 * @param res - raw adapter response
 * @returns T[] - list of models (empty array when missing)
 */
export function extractPageModels<T>(res: unknown): T[] {
  if (!res) return [];
  // Accept both generated adapter shapes and backend shapes. Some adapters/mocks
  // use `Models` (capitalized) while other API responses use `models` (lowercase).
  // Support both top-level and wrapped-in-data forms.
  const obj = res as Record<string, unknown>;
  const maybe =
    (obj.data as Record<string, unknown>)?.Models ??
    (obj.data as Record<string, unknown>)?.models ??
    obj.Models ??
    obj.models ??
    [];
  return Array.isArray(maybe) ? (maybe as T[]) : [];
}
